import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  Logout,
  Car,
  ShoppingBag,
  User,
  Radio,
  Document,
  Settings,
  Security,
  DataFormat,
  Run,
} from "@carbon/icons-react";
import siderbarLogo from "../../../assets/images/sidebar-logo.svg";
import userImg from "../../../assets/images/Mega.png";
import { DecryptData } from "../../../utils/Cipher";
import { usePermissions } from "../../../context/PermissionsContext";






const Sidebar = () => {

  const user = DecryptData();
  const { Permissions } = usePermissions();


  return (
    <>
      <nav className="sideNav">
        {/* <div className="logowrp">
          <img src={siderbarLogo} alt="" />
        </div> */}
        <div className="navwrp">
          <ul>
            <li>
              <Link className="character-btn" to="/dashboard">
                <img style={{ width: "80%" }} src={userImg} alt="" />
              </Link>
            </li>
            <li>
              <Link
                className="character-btn"
                to="/dashboard"
                uk-tooltip="title: Home; pos: right"
              >
                <Home />
              </Link>
            </li>

            {Permissions?.includes("oms-view") && (
            <li>
              <Link
                className="character-btn"
                to="/orders"
                uk-tooltip="title: OMS Vehicles; pos: right"
              >
                <Car />
              </Link>
            </li>
            )}

            
            <li>
              <Link
                className="character-btn"
                to="/customers"
                uk-tooltip="title: Customers; pos: right"
              >
                <User />
              </Link>
            </li>

            <li>
              <Link
                className="character-btn"
                to="/she-runs-applications"
                uk-tooltip="title: SHE RUNS Applications; pos: right"
              >
                <Run />
              </Link>
            </li>

            {Permissions?.includes("roles-view") && (
            <li>
              <Link
                className="character-btn"
                to="/role-management"
                uk-tooltip="title: Role Management; pos: right"
              >
                <Security />
              </Link>
            </li>
            )}

            



            <li>
              <button className="character-btn" type="button" style={{ color: 'white' }}><Document size={24} /></button>
              <div uk-dropdown="offset: 20;pos: right-top;delay-hide: 100" style={{width:'max-content', padding:'20px 10px'}}>
                {/* <h4>Surveys</h4> */}

                <ul className="uk-list uk-list-bullet  uk-text-left uk-padding-small" style={{width:'max-content'}}>
                  <li>  <Link
                    className="character-btn"
                    to="/survey-create"
                  >
                    <div className="">
                    <h5>Create Survey</h5>
                    </div>
                  </Link></li>


                  <li>
                    <Link
                      className="character-btn"
                      to="/survey-management"
                    >
                      <h5>Surveys Management</h5>
                    </Link>
                  </li>

                  <li>
                    <Link
                      className="character-btn"
                      to="/survey-campaigns"
                    >
                      <h5>Surveys Campaigns</h5>
                    </Link>
                  </li>




                </ul>
              </div>
            </li>


          

            

            <li>
              <Link
                className="character-btn"
                to="/Temp"
                uk-tooltip="title: OMS Accessories; pos: right"
              >
                <ShoppingBag />
              </Link>
            </li>

            

            <li>
              <Link
                className="character-btn"
                to="/Temp"
                uk-tooltip="title: Broadcast; pos: right"
              >
                <Radio />
              </Link>
            </li>


            <li>
              <Link
                className="character-btn"
                to="/Temp"
                uk-tooltip="title: Settings; pos: right"
              >
                <Settings />
              </Link>
            </li>
          </ul>
          <ul className="scnd-navwrp">
            <li className="onlineImg">
              <div className="userInfo ">
                <div className="uk-inline">
                  <button type="button" className="initialWrapper">
                    <span className="SidebarInitialImage">T</span>
                  </button>
                  <div
                    uk-dropdown="pos: right-top; mode: click"
                    className="navDropDown"
                    id="logoutProfileSection"
                  >
                    <ul className="uk-nav uk-dropdown-nav">
                      <li className="userDetails">
                        <div className="userImg initialWrapper">
                          <span className="SidebarInitialImage">T</span>
                          <span className="markProfile onlineMark"></span>
                        </div>
                        <div className="userData">
                          {/* <Link> */}
                          <h4>{user.name}</h4>
                          <p>{user.role}</p>
                          {/* </Link> */}
                        </div>
                      </li>
                     
                      <li className="dividingLine">
                        <hr />
                      </li>
                      {/* )} */}
                     

                      <li>
                        <button
                          onClick={() => {
                            localStorage.clear();
                            window.location.href = "/";
                          }}
                          type="button"
                          className="logoutBtn"
                        >
                          <Logout /> Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <span className="userOnlineIcon"></span> */}
              <span className="markProfileMain onlineMark"></span>
            </li>

            {/* <li
              className="onlineImg"
              uk-tooltip="title: Notifications; pos: right"
            >
              <Link to="/dashboard">
                <Notification />
              </Link>
              <span className="onlineIcon"></span>
            </li> */}
            {/* <li>
              <Link
                className="character-btn"
                to="/dashboard"
                uk-tooltip="title: Help; pos: right"
              >
                <Help />
              </Link>
            </li> */}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
